import { useEffect, useState } from "react";
import { getArtistCalendar } from "../../../api/artistApi";

const DAYS = ["S", "M", "T", "W", "T", "F", "S"];

const generateMonthDays = (year, month) => {
  const days = [];
  const lastDay = new Date(year, month, 0).getDate();

  for (let i = 1; i <= lastDay; i++) {
    const day = String(i).padStart(2, "0");
    days.push(`${year}-${String(month).padStart(2, "0")}-${day}`);
  }

  return days;
};

const BookingCalendar = ({
  artistId,
  selectedDate,
  setSelectedDate,
  //getArtistBookings,
}) => {
  const today = new Date();

  const [year] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth() + 1);

  const [calendarData, setCalendarData] = useState({});
  const [hoverInfo, setHoverInfo] = useState(null);

  const fetchCalendar = async () => {
    const data = await getArtistCalendar(artistId, year, month);

    const mapped = {};

    (data.bookings || []).forEach((booking) => {
      if (!mapped[booking.date]) {
        mapped[booking.date] = [];
      }
      mapped[booking.date].push(booking);
    });

    setCalendarData(mapped);
  };

  useEffect(() => {
    artistId && fetchCalendar();
  }, [artistId, year, month]);

  return (
    <div className="bg-slate-900/60 border border-white/10 rounded-xl p-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <button
          onClick={() => setMonth((m) => (m === 1 ? 12 : m - 1))}
          className="text-slate-400 hover:text-white"
        >
          ‹
        </button>

        <h2 className="text-white font-medium">
          {new Date(year, month - 1).toLocaleString("default", {
            month: "long",
            year: "numeric",
          })}
        </h2>

        <button
          onClick={() => setMonth((m) => (m === 12 ? 1 : m + 1))}
          className="text-slate-400 hover:text-white"
        >
          ›
        </button>
      </div>

      {/* Days */}
      <div className="grid grid-cols-7 gap-2 text-center text-xs text-slate-400 mb-2">
        {DAYS.map((d, i) => (
          <div key={`${d}+${i}`}>{d}</div>
        ))}
      </div>

      {/* Dates */}
      <div className="grid grid-cols-7 gap-2">
        {generateMonthDays(year, month).map((date) => {
          const bookings = calendarData[date] || [];

          const isSelected = selectedDate === date;
          const isBooked = bookings.length > 0;

          return (
            <button
              key={date}
              onClick={() => setSelectedDate(date)}
              onMouseEnter={() => bookings.length && setHoverInfo(bookings[0])}
              onMouseLeave={() => setHoverInfo(null)}
              className={`h-10 rounded text-sm flex items-center justify-center transition
                ${
                  isSelected
                    ? "bg-pink-600 text-white"
                    : isBooked
                      ? "bg-yellow-500 text-white"
                      : "text-slate-300 hover:bg-slate-800"
                }
              `}
            >
              {date.split("-")[2]}
            </button>
          );
        })}
      </div>

      {/* Hover Info */}
      {hoverInfo && (
        <div className="mt-4 text-xs text-slate-300 border border-white/10 p-3 rounded">
          <div>Promoter: {hoverInfo.promoter?.company_name}</div>
          <div>Status: {hoverInfo.status}</div>
          <div>Fee: {hoverInfo.agreed_fee}</div>
        </div>
      )}
    </div>
  );
};

export default BookingCalendar;
